export enum ScenarioSource {
  plugin = "plugin",
  system = "system",
  user = "user",
}
